/**
 * Felixmate'in sahipleri (ADR 0163): telif ve üretici yazan her kullanıcıya görünen yer bu adı
 * kullanır. Uygulama kimliği, yayıncı (`author`), alan adları ve e-postalar değişmez (§2).
 */
export const PRODUCT_OWNERS = 'Fluxesoft & Buga Marine Group';
